import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './TaskDate.module.css';
import { Icon } from '../Icon';

interface TaskDateProps {
    canOverdue: boolean;
    isOverdue: boolean;
    dateStart?: string | null;
    dateFinished?: string | null;
    classes?: string;
}

export const TaskDate = memo(
    ({ canOverdue, isOverdue, dateStart, dateFinished, classes }: TaskDateProps) => {
        if (!dateStart && !dateFinished) {
            return null;
        }

        return (
            <div className={classNames(cls.TaskDate, classes)}>
                <Icon
                    iconName="taskCalendar"
                    fill={isOverdue && canOverdue ? '#C1281B' : '#818998'}
                />
                {dateStart && (
                    <span
                        className={classNames(
                            cls.TaskDate_date,
                            isOverdue && canOverdue && cls.isOverdue
                        )}
                    >
                        {dateStart}
                    </span>
                )}
                {dateStart && dateFinished && <span>-</span>}
                {dateFinished && (
                    <span
                        className={classNames(
                            cls.TaskDate_date,
                            isOverdue && canOverdue && cls.isOverdue
                        )}
                    >
                        {dateFinished}
                    </span>
                )}
            </div>
        );
    }
);
